import React from "react";

export default function WritingSample({onClose}) {
    return (
        <>
            <div className="cvtemplate_pos">
                <div className="cvtemplate_bg">
                    <div className="cvtemplate_content">
                        <button className="close_btn" onClick={onClose}>
                            <img src="/assets/images/cross.svg" alt="" />
                        </button>
                        <h3>Writing Sample</h3>

                    </div>
                    <ol className="cvtemplate_list">
                        <li>Previously written work</li>
                        <li>or create a new one (3000- 5000 words)</li>
                 
                      
                    </ol>
                </div>
            </div>
        </>
    )
}